export const MARKET_BRAND_ROUTE_PATTERN =
  "usa-ford|usa-lincoln|canada-ford|canada-lincoln";

export const MARKET_BRAND_ROUTE_PREFIX = `/:marketBrand(${MARKET_BRAND_ROUTE_PATTERN})`;

export const getMarketSlug = (marketCode) => {
  const market = String(marketCode || "").toUpperCase();

  return market === "CAN" || market === "CANADA" ? "canada" : "usa";
};

export const getBrandSlug = (brandCode) =>
  String(brandCode || "").toUpperCase() === "L" ? "lincoln" : "ford";

export const getMarketBrandSlug = (marketCode, brandCode) =>
  `${getMarketSlug(marketCode)}-${getBrandSlug(brandCode)}`;

const analyticsTaggingContexts = {
  "usa-ford": { prefix: "fv", client: "ford-us", site: "fordvehicles.com" },
  "canada-ford": {
    prefix: "foc",
    client: "ford-canada",
    site: "ford.ca",
  },
  "usa-lincoln": { prefix: "ln", client: "lincoln", site: "lincoln.com" },
  "canada-lincoln": {
    prefix: "lnc",
    client: "canada",
    site: "lincolncanada.com",
  },
};

export const getAnalyticsTaggingContext = (marketCode, brandCode) =>
  analyticsTaggingContexts[getMarketBrandSlug(marketCode, brandCode)] ||
  analyticsTaggingContexts["usa-ford"];

export const getMarketBrandPath = (marketCode, brandCode, path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `/${getMarketBrandSlug(marketCode, brandCode)}${normalizedPath}`;
};

export const getMarketBrandRoute = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${MARKET_BRAND_ROUTE_PREFIX}${normalizedPath}`;
};
